import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'ngx-modal-primeira-via',
  templateUrl: './modal-primeira-via.component.html',
  styleUrls: ['./modal-primeira-via.component.scss']
})
export class ModalPrimeiraViaComponent implements OnInit {

  @Input() nome: string;
  @ViewChild("card", null)

  private card: ElementRef;
  public formModalInfo = null;

  constructor(
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<ModalPrimeiraViaComponent>
  ) { }

  ngOnInit() {
    this.card.nativeElement.ownerDocument.activeElement.blur();
  }

  voltar() {
    this.ref.close();
  }

}
